import React, { useState, useRef, DragEvent } from 'react';
import '../styles/InputPage.css';
import { authFetch } from '../utils/authFetch'; // <-- IMPORTAÇÃO ADICIONADA

export const InputPage = () => {
  const [file, setFile] = useState<File | null>(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (selectedFile: File | null) => {
    if (selectedFile && (selectedFile.name.endsWith('.xlsx') || selectedFile.name.endsWith('.xls'))) {
      setFile(selectedFile);
      setErrorMessage('');
    } else {
      setErrorMessage('Formato inválido. Por favor, selecione um arquivo Excel (.xlsx ou .xls).');
    }
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragOver(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileSelect(e.dataTransfer.files[0]);
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleUpload = async () => {
    if (!file) {
      setErrorMessage('Nenhum arquivo selecionado.');
      return;
    }

    setUploadStatus('Enviando...');
    setErrorMessage('');
    const formData = new FormData();
    formData.append('file', file);

    try {
      // Usa a nova função authFetch. Ela já cuida da autenticação e do erro 401.
      // Ela também é inteligente o suficiente para não adicionar 'Content-Type' quando o body é FormData.
      const response = await authFetch('/api/forakit/upload', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.detail || 'Ocorreu um erro no upload.');
      }

      setUploadStatus(result.message);
      setFile(null);
    } catch (error: any) {
      setUploadStatus('');
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="input-page-container">
      <h1>Input de Planilha</h1>
      <p>Arraste e solte a planilha do Fora Kit ou clique para selecionar o arquivo.</p>

      <div 
        className={`drop-zone ${isDragOver ? 'drag-over' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={triggerFileSelect}
      >
        <input 
          type="file" 
          ref={fileInputRef}
          onChange={(e) => handleFileSelect(e.target.files ? e.target.files[0] : null)}
          accept=".xlsx, .xls"
          style={{ display: 'none' }}
        />
        {file ? (
          <p className="file-name">Arquivo selecionado: {file.name}</p>
        ) : (
          <p>Arraste o arquivo aqui ou clique para selecionar</p>
        )}
      </div>

      {file && (
        <button className="upload-btn" onClick={handleUpload}>
          Imputar Planilha
        </button>
      )}

      {uploadStatus && <p className="status-message success">{uploadStatus}</p>}
      {errorMessage && <p className="status-message error">{errorMessage}</p>}
    </div>
  );
};
